
  <div class="filter-container">
    <form [formGroup]="byPriorityForm">
      <div formArrayName="priorities">
        <div
          class="sgc"
          *ngFor="let priorityCtrl of priorities.controls; let i = index"
        >
          <single-choice
            [formControl]="priorityCtrl"
            (click)="setEditingIndex(i)"
            [completedUrl]="completionUrl"
            [topic]="'priority'"
            [editMode]="true"
            [ticketId]="fakeId"
            [icon]="'error_circle'"
            (choiceEvent)="relaySingleChoice($event)"
            [labelOnDemand]="priorityLabelerByService"
            [choiceObserver]="priorityObserver"
          ></single-choice>
        </div>
      </div>

      <button
        type="button"
        class="add-priority-btn"
        (click)="addPriorityField()"
      >
        +
      </button>

      <not
        [filter]="byPriorityFilter"
        (filterChanged)="onFilterChanged($event)"
      ></not>

      <button class="apply-filter-btn" type="submit" (click)="apply()">
        Apply
      </button>
    </form>
  </div>
